import Input from '@porterin/component-library/src/base-components/input/Input';
import React, { forwardRef } from 'react';

type inputInteractions = {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
};

type inputOptions = {
  disabled?: boolean;
  placeholder?: string;
  error?: string;
};

type identifiers = {
  id: string;
};

type inputIcons = {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
};

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  identifiers: identifiers;
  interactions?: inputInteractions;
  inputOptions?: inputOptions;
  icons?: inputIcons;
  className?: string;
}

const TextInput = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      identifiers,
      interactions,
      inputOptions,
      icons,
      className = '',
      autoFocus = false,
      ...props
    },
    ref,
  ) => {
    return (
      <div className="relative w-full" id={identifiers?.id}>
        <div className="relative">
          {icons?.leftIcon && (
            <div className="absolute inset-y-0 left-0 pl-6 flex items-center pointer-events-none">
              {icons.leftIcon}
            </div>
          )}
          <Input
            identifiers={{ id: `input-${identifiers.id}` }}
            interactions={interactions}
            inputOptions={inputOptions}
            autoFocus={autoFocus}
            ref={ref}
            className={`
							${icons?.leftIcon && 'pl-16'}
              ${icons?.rightIcon && 'pr-16'}
              ${inputOptions?.error && 'border-[#DB230A] focus:[#DB230A]'} // TODO: add colors to tailwind config and use from there
							${className}
						`}
            {...props}
          />
          {icons?.rightIcon && (
            <div className="absolute inset-y-0 right-0 pr-6 flex items-center">
              {icons.rightIcon}
            </div>
          )}
        </div>
        {inputOptions?.error && (
          <div
            id={`text-input-error-${identifiers.id}`}
            className="mt-5 text-left text-sm font-normal text-red-500 absolute top-14 normal-case"
          >
            {inputOptions.error}
          </div>
        )}
      </div>
    );
  },
);

export default TextInput;
